import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  Typography,
  App,
  Breadcrumb,
  Space,
  theme,
  Card,
  Row,
  Col,
  Switch,
} from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useAuth } from "../../context/AuthProvider";
import ForbiddenPage from "../Status/ForbiddenPage";
import { getBackendUrl } from "../../utils/env";
import axios from "axios";

const { Title, Text } = Typography;

export default function AdminMenuDashboard() {
  const { message } = App.useApp();
  const { user } = useAuth();
  const { token } = theme.useToken();
  const navigate = useNavigate();

  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user?.id === 1) {
      fetchMenuSettings();
    }
  }, [user]);

  const fetchMenuSettings = async () => {
    setLoading(true);

    try {
      const res = await axios.get(
        `${getBackendUrl()}api/admin/menu.php`
      );

      if (res.data.success) {
        setMenuItems(res.data.data);
      } else {
        message.error("No se pudo cargar la configuración del menú.");
      }
    } catch {
      message.error("Error al cargar la configuración.");
    } finally {
      setLoading(false);
    }
  };

  const updateMenu = async (menuKey, enabled) => {
    try {
      const res = await axios.put(
        `${getBackendUrl()}api/admin/menu.php`,
        {
          menu_key: menuKey,
          enabled,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data.success) {
        message.success("Configuración actualizada.");

        setMenuItems(prev =>
          prev.map(item =>
            item.key === menuKey
              ? { ...item, enabled }
              : item
          )
        );
      } else {
        message.error(res.data.message);
      }
    } catch {
      message.error("Error al actualizar.");
    }
  };

  const columns = [
    {
      title: "Opción",
      dataIndex: "label",
      key: "label",
      render: text => (
        <Text strong style={{ color: token.colorTextHeading }}>
          {text}
        </Text>
      ),
    },
    {
      title: "Visible",
      dataIndex: "enabled",
      key: "enabled",
      align: "center",
      width: 180,
      render: (enabled, record) => (
        <Switch
          checked={enabled}
          checkedChildren="Sí"
          unCheckedChildren="No"
          onChange={checked =>
            updateMenu(record.key, checked)
          }
        />
      ),
    },
  ];

  if (user?.id !== 1) return <ForbiddenPage />;

  return (
    <div
      style={{
        padding: "clamp(16px,4vw,32px)",
        maxWidth: 900,
        margin: "0 auto",
        backgroundColor: token.colorBgLayout,
        minHeight: "100vh",
      }}
    >
      <Breadcrumb
        style={{ marginBottom: 24 }}
        items={[
          {
            title: (
              <span
                style={{
                  cursor: "pointer",
                  color: token.colorPrimary,
                }}
                onClick={() => navigate("/admin")}
              >
                Panel de Administración
              </span>
            ),
          },
          {
            title: "Configuración del Menú",
          },
        ]}
      />

      <Row
        justify="space-between"
        align="middle"
        style={{ marginBottom: 24 }}
      >
        <Col>
          <Space align="center" size="middle">
            <div
              style={{
                backgroundColor: token.colorPrimaryBg,
                padding: 10,
                borderRadius: token.borderRadius,
                display: "flex",
              }}
            >
              <MenuOutlined
                style={{
                  fontSize: 20,
                  color: token.colorPrimary,
                }}
              />
            </div>

            <div>
              <Title level={3} style={{ margin: 0 }}>
                Configuración del Menú
              </Title>

              <Text type="secondary">
                Activa o desactiva las opciones visibles para los
                usuarios.
              </Text>
            </div>
          </Space>
        </Col>
      </Row>

      <Card
        style={{
          borderRadius: token.borderRadiusLG,
          boxShadow: token.boxShadowTertiary,
          border: `1px solid ${token.colorBorderSecondary}`,
        }}
        bodyStyle={{
          padding: token.paddingSM,
        }}
      >
        <Table
          rowKey="key"
          columns={columns}
          dataSource={menuItems}
          loading={loading}
          pagination={false}
          scroll={{ x: 500 }}
        />
      </Card>
    </div>
  );
}